import React, { useEffect, useState, useRef } from 'react';
import { KTIcon } from '../../../_metronic/helpers';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { useTranslation } from 'react-i18next';
import { AttachmentUpload } from '../../../features/attachment/AttachmentUpload';
import GetAttachments from '../../../features/attachment/AttachmentItem';
import { updateProjectAttachment } from '../projectSlice';
import { getValueFromResource } from '../../../common/timeLiveFunction';

const AccountProjectAttachment = (props: any) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const { isAttachment } = useAppSelector((state) => state.project);
    const [tempAttachmentId, setTempAttachmentId] = useState(null);
    const attachmentUploadClearRef = useRef<any>(null);

    useEffect(() => {

    }, []);

    const updateTempAttachmentId = (value: any) => {
        setTempAttachmentId(value);
    }

    return (
        <div className='modal drawer-overlay' tabIndex={-1} data-bs-backdrop="false" id='attachmentModel' role="dialog" aria-labelledby="exampleModalSizeSm" aria-hidden="true">
            <div className="modal-dialog modal-xl">
                <div className="modal-content rounded">
                    <div className='modal-header pb-2'>
                        <h3 className='headerTitle'>
                            {/* {t('Attachment')} */}
                            {getValueFromResource('Attachment',dispatch, t)}

                            </h3>
                        <div className='btn btn-sm btn-icon btn-active-color-primary' data-bs-dismiss='modal'
                            onClick={() => { dispatch(updateProjectAttachment(false)) }}
                        >
                            <KTIcon iconName='cross' className='fs-1' />
                        </div>
                    </div>
                    <div className='modal-body pt-0 pb-15 px-5 px-xl-5' style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 300px)' }}>
                        <AttachmentUpload
                            Id={props.accountProjectId}
                            onupdateTempAttachmentId={updateTempAttachmentId}
                            clearRef={attachmentUploadClearRef}
                            AccountAttachmentTypeId={4}
                        />
                        {props.accountProjectId > 0 && isAttachment && <GetAttachments Id={props.accountProjectId} AccountAttachmentTypeId={4} IsShowEmployeeInformation={false} />}
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary btn-bs-btn-font-weight me-2 btn-sm fs-7"
                            data-bs-dismiss="modal"
                            onClick={() => { dispatch(updateProjectAttachment(false)) }}
                        >
                            {/* {t('Cancel')} */}
                            {/* {getValueFromResource('Cancel',dispatch, t)} */}
                            {getValueFromResource('Close',dispatch, t)}

                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AccountProjectAttachment